
import { defineComponent } from "vue";

export default defineComponent({
  name: "plus-sign-svg"
})
